import React, { useEffect, useState } from "react";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Footer from "@/components/Footer";
import StockOverview from "@/components/StockOverview";
import FinancialMetrics from "@/components/FinancialMetrics";
import FinancialCharts from "@/components/FinancialCharts";
import AdvantagesRisks from "@/components/AdvantagesRisks";
import AIScoreRadar from "@/components/AIScoreRadar";
import NewsFeed from "@/components/NewsFeed";
import CompetitorTable from "@/components/CompetitorTable";
import AIReport from "@/components/AIReport";
import AIChat from "@/components/AIChat";
import PdfExportButton from "@/components/PdfExportButton";
import LoadingSkeleton from "@/components/LoadingSkeleton";
import ErrorState from "@/components/ErrorState";
import { fetchStock } from "@/lib/api";

function nowStamp() {
  const d = new Date();
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(
    d.getHours()
  )}:${pad(d.getMinutes())}`;
}

export default function Dashboard() {
  const [ticker, setTicker] = useState("");
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [updatedAt, setUpdatedAt] = useState("");

  const load = async (t) => {
    if (!t) return;
    setLoading(true);
    setError("");
    setData(null);
    setTicker(t);
    try {
      const d = await fetchStock(t);
      setData(d);
      setUpdatedAt(nowStamp());
      // Scroll to top of dashboard content
      window.scrollTo({ top: 0, behavior: "smooth" });
    } catch (e) {
      const msg =
        e?.response?.data?.detail ||
        "找不到符合的股票，請確認股票代碼或公司名稱是否正確。";
      setError(typeof msg === "string" ? msg : "系統錯誤，請稍後再試");
    } finally {
      setLoading(false);
    }
  };

  const clear = () => {
    setTicker("");
    setData(null);
    setError("");
  };

  return (
    <div className="min-h-screen bg-background text-foreground">
      <Header
        onSelect={(t) => (t ? load(t) : clear())}
        hasStock={!!(data || loading || error)}
        updatedAt={updatedAt}
      />

      {!data && !loading && !error && <Hero onSelect={load} />}

      {(loading || error || data) && (
        <main className="max-w-[1600px] mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-8">
          {loading && <LoadingSkeleton />}
          {error && !loading && <ErrorState message={error} onRetry={clear} />}
          {data && !loading && (
            <div className="space-y-8 stagger">
              <StockOverview data={data} />
              <FinancialCharts data={data} />
              <FinancialMetrics data={data} />
              <AIScoreRadar score={data.ai_score} />
              <AdvantagesRisks data={data} />
              <CompetitorTable data={data} />
              <NewsFeed news={data.news} />
              <AIReport data={data} />
              <PdfExportButton ticker={data.ticker} name={data.name_zh || data.name} />
              <div className="no-print">
                <AIChat ticker={data.ticker} name={data.name_zh || data.name} />
              </div>
            </div>
          )}
        </main>
      )}

      <Footer />
    </div>
  );
}
